import { LoadingCentered } from '@c42/component-library';
import { Box } from '@mui/material';
import React from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router';
import {
  DEFAULT_REDIRECT_AFTER_LOGIN,
  FORGOT_PASSWORD_INDEX,
  SUPPORT_LOGIN_AUDIT_INDEX,
  LOGIN_INDEX,
  NOT_AUTHORIZED_INCYDR_INDEX,
  RESET_PASSWORD_INDEX,
  SSO_INCORRECT_LOGIN,
  SSO_INCORRECT_LOGIN_TRY_AGAIN,
  SSO_INDEX,
  SSO_SUCCESS_CP3,
  SUPPORT_LOGIN_INDEX,
  SUPPORT_SSO_ERROR,
} from '../constants/routes';
import { NAV_EXTERNALS } from '../utils/nav';
import ForgotPassword from './forgot-password-form';
import LoginFormWizard from './login-form/wizard';
import LoginWrapper from './login-wrapper';
import NotAuthorizedForIncydr from './not-authorized-for-incydr';
import { STEP_PASSWORD, STEP_USERNAME } from './providers/auth/context';
import { useAuthData } from './providers/auth/hooks';
import { useMainData } from './providers/main/context';
import ResetPassword from './reset-password-form';
import SsoAuthLoginIncorrect from './sso-auth-login-incorrect';
import SsoAuthLoginIncorrectTryAgain from './sso-auth-login-incorrect-try-again';
import SsoAuthLoginSuccessCp3 from './sso-auth-login-success_cp3';
import Sso from './sso/sso-form';
import LoginAuditLog from './login-audit-log/login-audit-log';
import SupportLoginForm from './support-login/support-login-form';
import SupportSsoError from './support-sso-error';

const Main: React.FC = () => {
  const location = useLocation();

  const { isInitialized, isValidatingToken } = useMainData();

  const { currentStep, serverType } = useAuthData();
  const isStorageNode = serverType?.storage;

  const isForgotPasswordVisible = (): boolean => {
    // Show link on only the first two steps of login form.
    const allowedSteps = [STEP_USERNAME, STEP_PASSWORD];
    const isStepAllowed = allowedSteps.indexOf(currentStep) > -1;

    // Show link on all routes except the forgotten password route.
    const isRouteAllowed = location.pathname !== FORGOT_PASSWORD_INDEX;

    // Do not show "forgot password" on storage node login.
    const showAccountRecoveryLinks = !isStorageNode;

    return showAccountRecoveryLinks && isStepAllowed && isRouteAllowed;
  };

  const ignoreWrapper = [
    SUPPORT_LOGIN_AUDIT_INDEX,
    NOT_AUTHORIZED_INCYDR_INDEX,
    SSO_INCORRECT_LOGIN,
    SSO_SUCCESS_CP3,
    SSO_INCORRECT_LOGIN_TRY_AGAIN,
    SUPPORT_SSO_ERROR,
  ].includes(location.pathname);

  if (isValidatingToken) {
    return (
      <LoginWrapper isForgotPasswordVisible={false} ignoreWrapper={ignoreWrapper}>
        <Box height={100} position="relative">
          <LoadingCentered />
        </Box>
      </LoginWrapper>
    );
  }

  if (isInitialized) {
    const RedirectToConsole = () => {
      NAV_EXTERNALS.cypressLocationReplace(DEFAULT_REDIRECT_AFTER_LOGIN);
      return null;
    };

    return (
      <LoginWrapper isForgotPasswordVisible={isForgotPasswordVisible()} ignoreWrapper={ignoreWrapper}>
        <Switch>
          <Route path={FORGOT_PASSWORD_INDEX} component={ForgotPassword} />
          <Route path={LOGIN_INDEX} component={LoginFormWizard} />
          <Route path={RESET_PASSWORD_INDEX} component={ResetPassword} />
          <Route path={SSO_INDEX} component={Sso} />
          <Route path={SUPPORT_LOGIN_INDEX} component={SupportLoginForm} />
          <Route path={SUPPORT_LOGIN_AUDIT_INDEX} component={LoginAuditLog} />
          <Route path={NOT_AUTHORIZED_INCYDR_INDEX} component={NotAuthorizedForIncydr} />
          <Route path={SSO_INCORRECT_LOGIN} component={SsoAuthLoginIncorrect} />
          <Route path={SSO_SUCCESS_CP3} component={SsoAuthLoginSuccessCp3} />
          <Route path={SSO_INCORRECT_LOGIN_TRY_AGAIN} component={SsoAuthLoginIncorrectTryAgain} />
          <Route path={SUPPORT_SSO_ERROR} component={SupportSsoError} />
          <Route path="/landing" component={RedirectToConsole} />
          <Route>
            <Redirect to={LOGIN_INDEX} />
          </Route>
        </Switch>
      </LoginWrapper>
    );
  }

  return <div />;
};

export default Main;
